import React from 'react';
import PropTypes from 'prop-types';
import {getPlatform} from "@/hooks";

// Storefront behaviour will default the value of the customers language to the language of the storefront,
// this is a visual representation of that value that was required for the DataCandy Integration
const LanguagePicker = ({
    baseClass,
    language,
    handleChange,
}) => {

    if (getPlatform() === 'web') {
        return (
            <div
                className={baseClass('-language m2g-input-container')}
            >
                <input
                    type="radio"
                    value="en"
                    id="languageEnglish"
                    name="language"
                    className={baseClass('-language-input')}
                    checked={language === 'en'}
                    onChange={(e) => handleChange(e.target.value)}
                />
                <label
                    htmlFor="languageEnglish"
                    className={baseClass('-language-button--english m2g-button m2g-button--primary')}
                >
                    English
                </label>

                <input
                    type="radio"
                    value="fr"
                    id="languageFrench"
                    name="language"
                    className={baseClass('-language-input')}
                    checked={language === 'fr'}
                    onChange={(e) => handleChange(e.target.value)}
                />
                <label
                    htmlFor="languageFrench"
                    className={baseClass('-language-button--french m2g-button m2g-button--primary')}
                >
                    Français
                </label>
            </div>
        );
    }

    return (
        <div
            className={baseClass('-language')}
        >
            <input
                type="radio"
                value="en"
                id="languageEnglish"
                name="language"
                className={baseClass('-language-input')}
                checked={language === 'en'}
                onChange={(e) => handleChange(e.target.value)}
            />
            <label
                htmlFor="languageEnglish"
                className={baseClass('-language-button--english m2g-button m2g-button--primary m2g-touchable')}
            >
                English
            </label>

            <input
                type="radio"
                value="fr"
                id="languageFrench"
                name="language"
                className={baseClass('-language-input')}
                checked={language === 'fr'}
                onChange={(e) => handleChange(e.target.value)}
            />
            <label
                htmlFor="languageFrench"
                className={baseClass('-language-button--french m2g-button m2g-button--primary m2g-touchable')}
            >
                Français
            </label>
        </div>
    );
};

LanguagePicker.propTypes = {
    baseClass: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
};

export default LanguagePicker;
